import { Button, Carousel, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { AdvertType, CarouselImage } from '../../types/baseTypes'
import { PopoverContainer, StyledHomeSlideShow, StyledPromotion, StyledSearch } from './SlideShow.styled'
import { Loader } from 'components/Loader'
import { useFetch } from 'hooks/useFetch'
import { saveAs } from 'file-saver'
import { getCarouselImages } from 'apis/dashboardApis'
import { useGlobalStore } from 'store/useGlobalStore'

export const SlideShow = () => {
  const { loading, data } = useFetch(() => getCarouselImages())
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])

  const clickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, item: CarouselImage) => {
    e.preventDefault()
    if (item.AdvertType === AdvertType.PictureOnly) return
    if (item.DocumentURL) saveAs(item.DocumentURL, item.DocumentName)
  }

  return (
    <StyledHomeSlideShow assetFolder={assetFolder}>
      <Carousel interval={5000} fade={true} controls={false} indicators={data?.length > 1}>
        {!loading ? (
          data?.map((item, index) => (
            <Carousel.Item key={index}>
              <LazyLoadImage
                placeholder={<img className="d-block w-100" />}
                onClick={(e) => clickHandler(e, item)}
                className={`d-block w-100 h-100 ${item.AdvertType !== AdvertType.PictureOnly && 'clickable'}`}
                src={item.ImageURL}
              />
              <Carousel.Caption
                style={item.AdvertType !== AdvertType.PictureOnly ? { marginTop: '-3rem', paddingBottom: '0' } : null}
              >
                {item.AdvertType !== AdvertType.PictureOnly && (
                  <StyledPromotion style={{ paddingTop: '-1rem' }}>
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      placement="bottom"
                      overlay={<PopoverContainer>{item.Description}</PopoverContainer>}
                    >
                      <span>{item.Description}</span>
                    </OverlayTrigger>
                    <StyledSearch onClick={(e) => clickHandler(e, item)}>
                      <Button>LEARN MORE</Button>
                    </StyledSearch>
                  </StyledPromotion>
                )}
              </Carousel.Caption>
            </Carousel.Item>
          ))
        ) : (
          <Carousel.Item>
            <img className="d-block w-100" alt={''} />
            <Loader overlay />
          </Carousel.Item>
        )}
      </Carousel>
    </StyledHomeSlideShow>
  )
}
